import React from 'react';
import { Route, Navigate } from 'react-router-dom';

// Layout
import BumdesLayout from '../layouts/BumdesLayout';

// Components
import ProtectedRoute from '../Components/ProtectedRoute';

// Pages
import BumdesHome from '../Pages/Bumdes/BumdesHome';
import BumdesPreSurvey from '../Pages/Bumdes/BumdesPreSurvey';
import BumdesVeci from '../Pages/Bumdes/BumdesVeci';
import BumdesBmc from '../Pages/Bumdes/BumdesBmc';

const bumdesRoutes = () => (
  <Route path='bumdes'>
    {/* Halaman khusus mitra BUMDes */}
    <Route element={<ProtectedRoute allowedRoles={['Bumdes']} />}>
      <Route element={<BumdesLayout />}>
        <Route
          index
          element={<BumdesHome />}
        />
        <Route
          path='home'
          element={
            <Navigate
              to='/bumdes'
              replace
            />
          }
        />
        <Route
          path='pre-survey'
          element={<BumdesPreSurvey />}
        />
        <Route
          path='veci'
          element={<BumdesVeci />}
        />
        <Route path="bmc" element={<BumdesBmc />} />
      </Route>
    </Route>
  </Route>
);

export default bumdesRoutes;
